import axios from 'axios';


let helper = {
    event: {},
    student: '',
    notification: {},
    startNofication: 0,
    dateEvent: 0,
    startNotification24: 0,
    startRating: 0,
    startRatingLater:0
};

const urlHelper = 'https://us-central1-vida-anahuac.cloudfunctions.net/getNotificationHelper';
const urlFavoriteAdd = 'https://us-central1-vida-anahuac.cloudfunctions.net/addStudentFavoriteRequest';
const urlFavoriteRemove = 'https://us-central1-vida-anahuac.cloudfunctions.net/removeStudentFavoriteRequest';

const urlEventAdd = 'https://us-central1-vida-anahuac.cloudfunctions.net/addStudentToEventRequest';
const urlEventRemove = 'https://us-central1-vida-anahuac.cloudfunctions.net/removeStudentToEventRequest';

const urlCancelEvent = "https://us-central1-vida-anahuac.cloudfunctions.net/removeAllEventsToUserAndNotify";
const allNotifications = "https://us-central1-vida-anahuac.cloudfunctions.net/markNotificationsForStudentRequest";

const notifyEventChange = "https://us-central1-vida-anahuac.cloudfunctions.net/notifyEventChangeRequest";
const urlCreateHelper = "https://us-central1-vida-anahuac.cloudfunctions.net/createNotificationHelperFromWeb";

const urlRatingAdd = "https://us-central1-vida-anahuac.cloudfunctions.net/addRatingReminderRequest";
const urlRatingRemove = "https://us-central1-vida-anahuac.cloudfunctions.net/removeRatingDataRequest";
const urlRatingDeleteAll = "https://us-central1-vida-anahuac.cloudfunctions.net/removeAllRatingData";


export default class NotificationService {

    
    async getHelperStored(userEmail, nameHelper, userData = null) {

        if(helper.student)
        return { data: helper.notification};

        helper = await axios.post(
            urlHelper,
            {
                email: userEmail
            }
        );

        if(!helper.data && userData) {
            await this.createNotificationHelperIntoFirebase(userEmail, userData);
            return {
                data: {
                    campus: userData.claveCampus,
                    id: userEmail,
                    name: `${userData.nombre} ${userData.apellidoPaterno} ${userData.apellidoMaterno}`,
                    token: "",
                    email: userEmail,
                }
            };
        }

        if (nameHelper) 
        helper.data.name = nameHelper;

        return helper;
    }

    async createNotificationHelperIntoFirebase(userEmail, userData) {
        await axios.post(
            urlCreateHelper,
            {
                campus: userData.claveCampus,
                id: userEmail,
                name: `${userData.nombre} ${userData.apellidoPaterno} ${userData.apellidoMaterno}`,
                token: "",
                email: userEmail,
            }
        );
    }

        /**
     * Create Helper that includes information about notification and event
     */
    createHelper(eventData, notificationHelper) {

        helper = {
            event: {...eventData},
            student: notificationHelper.id,
            notification: {...notificationHelper},
            startNotification: this._generateEpochTime(eventData.fechaInicio, eventData.horaInicio, -2, 'hours'),
            startNotification24: this._generateEpochTime(eventData.fechaInicio, eventData.horaInicio, -1, 'days'),
            dateEvent: this._generateEpochTime(eventData.fechaInicio, eventData.horaInicio),
            startRating: this._generateEpochTime(eventData.fechaInicio, eventData.horaInicio, -5, 'minutes'),
            startRatingLater: this._generateEpochTime(eventData.fechaInicio, eventData.horaInicio, 3, 'hours'),
        }

        return helper;
    }

    _generateEpochTime(dateT, hour, add, type) {

        let date = new Date(dateT+' '+hour);

        if (type == 'days') {
            date.setDate(date.getDate() + add);
        } else if (type == 'hours') {
            date.setTime(date.getTime() + (add*60*60*1000));
        } else if (type == 'minutes') {
            date.setDate(date.getTime() + (add * 60 * 1000));
        }

        return date.valueOf();

    }

    saveFavoriteNotification(helperT) {
        axios.post(
            urlFavoriteAdd,
            {
                ...helperT
            }
        );
    }

    deleteFavoriteNotification(helperT) {
        axios.post(
            urlFavoriteRemove,
            {
                ...helperT,
            }
        );
    }

    saveEventNotification(helperT) {
        axios.post(
            urlEventAdd,
            {
                ...helperT
            }
        );
    }

    removeEventNotification(helperT) {
        axios.post(
            urlEventRemove,
            {
                ...helperT
            }
        );
    }

    cancelEventComplete(helperT) {
        axios.post(
            urlCancelEvent,
            {
                ...helperT
            }
        );
    }

    markNotificationForAllStudents(eventId, students, eventData) {
        axios.post(
            allNotifications,
            {
                event: {
                    ...eventData,
                    id: eventId,
                },
                students: students,
                startNotification: this._generateEpochTime(eventData.fechaInicio, eventData.horaInicio, -2, 'hours'),
                startNotification24: this._generateEpochTime(eventData.fechaInicio, eventData.horaInicio, -1, 'days'),
                dateEvent: this._generateEpochTime(eventData.fechaInicio, eventData.horaInicio),
            }
        );
    }

    detectChangeInEvent(oldEvent, newEvent) {
        let reason = null;
        if (oldEvent.fechaInicio != newEvent.fechaInicio) {
            reason = "date";
        }

        if (oldEvent.horaInicio != newEvent.horaInicio) {
            reason = "time";
        }

        if (oldEvent.fechaInicio != newEvent.fechaInicio && oldEvent.horaInicio != newEvent.horaInicio) {
            reason = "dateTime";
        }

        return reason;
    }

    updateAndNotifyEventChanges(eventData, eventId, typeChange) {
        axios.post(
            notifyEventChange,
            {
                event: {
                    ...eventData,
                    id: eventId,
                },
                type: typeChange,
                startNotification: this._generateEpochTime(eventData.fechaInicio, eventData.horaInicio, -2, 'hours'),
                startNotification24: this._generateEpochTime(eventData.fechaInicio, eventData.horaInicio, -1, 'days'),
                dateEvent: this._generateEpochTime(eventData.fechaInicio, eventData.horaInicio),
            }
        );
    }

    async isEventValid(eventId, tokenData) {
        const authData = tokenData; 
        const oHeaders = { headers: { 'Authorization': authData.token_type + ' ' + authData.access_token } };
        const data = await axios.post(
            process.env.VUE_APP_API_URL + "api/evento/valid",
            {
                eventId: eventId,
                date: new Date().toISOString()
            },
            oHeaders
        );

        return data.data.data.result;
    }


    removeRatingNotification(helperT) {
        axios.post(
            urlRatingRemove,
            {
                ...helperT
            }
        );
    }
    
    addRatingNotifcation(helperT) {
        axios.post(
            urlRatingAdd,
            {
                ...helperT
            }
        );
    }

    removeAllRatingData(helperT) {
        axios.post(
            urlRatingDeleteAll,
            {
                ...helperT
            }
        );
    }
}